"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LaTeXDisplay = void 0;

var _react = _interopRequireDefault(require("react"));

var _mathjax = _interopRequireDefault(require("@nteract/mathjax"));

var LaTeXDisplay = function LaTeXDisplay(props) {
  return _react["default"].createElement(_mathjax["default"].Text, null, props.data);
};

exports.LaTeXDisplay = LaTeXDisplay;
LaTeXDisplay.MIMETYPE = "text/latex";
var _default = LaTeXDisplay;
exports["default"] = _default;